import { memo } from 'react'
import style from './style.module.scss'
import backIcon from 'src/assets/img/icons/arrow-left.svg'

interface BackBtnProps {
  onClick?: () => void
}

const BackBtn = ({ onClick }: BackBtnProps) => {
  if (!onClick) {
    onClick = () => {
      window.history.back()
    }
  }

  return (
    <button className={style.back_btn} onClick={onClick}>
      <img src={backIcon} alt="arrow" />
    </button>
  )
}

export default memo(BackBtn)
